import React, { Fragment, PureComponent } from 'react';
import TextMask from 'react-text-mask';
import { Button } from 'reactstrap';
import FormItem from '../../components/FormItem';
import Input from '../../components/Input';
import InputRadio from '../../components/InputRadio';
import PageTitle from '../../components/PageTitle';
import { getErrorMessage } from '../../helpers/errors';
import { isValidPhone, readDate, toDay, toDigits } from '../../helpers/form';
import { digits, masks } from '../../helpers/format';
import { setFieldValueGen } from '../../helpers/utils';
import GoKids from '../../services/GoKids';

class DriverForm extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      template: readFromServer(this.props.initialValues)
    };

    this.setFieldValue = setFieldValueGen(this, 'template');
  }

  componentWillMount() {
    if (this.props.match.params.id) this.loadFromApi();
  }

  async loadFromApi() {
    try {
      this.setState({ isSubmitting: true, isEditing: true });
      const driver = await GoKids.getDriver(this.props.match.params.id);
      const template = readFromServer(driver);

      this.setState({ isSubmitting: false, original: driver, template });
    } catch (err) {
      const errorMessage = getErrorMessage(err);
      this.setState({ isSubmitting: true, errorMessage });
    }
  }

  handleSubmit = async e => {
    e.preventDefault();

    const { template } = this.state;
    let errorMessage = validateTemplate(template);
    if (errorMessage) return this.setState({ isSubmitting: false, errorMessage });

    try {
      const driverId = this.props.match.params.id;
      this.setState({ isSubmitting: true });

      const data = readFromTemplate(template);
      await GoKids.upsertDriver(data, driverId);
      this.props.history.push('/maetoristas');
    } catch (err) {
      const errorMessage = getErrorMessage(err);
      this.setState({ isSubmitting: false, errorMessage });
    }
  };

  render() {
    const accessFields = this.renderAccessFields();
    const infoFields = this.renderInfoFields();
    const docFields = this.renderDocFields();

    const isEditing = !!this.props.match.params.id;
    const title = isEditing ? 'Editar mãetorista' : 'Adicionar mãetorista';

    return (
      <Fragment>
        <PageTitle title={title} />
        <form className="card card-form" onSubmit={this.handleSubmit}>
          <div className="card-form-body">
            <h4 className="form-subheader">Sobre a mãetorista</h4>
            {infoFields}

            <h4 className="form-subheader">Documentação</h4>
            {docFields}

            <h4 className="form-subheader">Dados de acesso</h4>
            {accessFields}

            <div className="form-actions">
              <span className="flex text-danger">{this.state.errorMessage || ''}</span>
              <Button disabled={this.state.isSubmitting} color="primary" type="submit">
                Enviar
              </Button>
            </div>
          </div>
        </form>
      </Fragment>
    );
  }

  renderInfoFields = () => {
    const { template } = this.state;
    return (
      <Fragment>
        <FormItem label="Nome completo">
          <Input name="fullName" value={template.fullName} onChange={this.setFieldValue} />
        </FormItem>
        <FormItem label="Como é chamado">
          <Input name="nickname" value={template.nickname} onChange={this.setFieldValue} />
        </FormItem>
        <FormItem label="Sexo" valign="start">
          <InputRadio
            name="gender"
            value="F"
            label="Feminino"
            checked={template.gender === 'F'}
            onChange={this.setFieldValue}
          />
          <InputRadio
            name="gender"
            value="M"
            label="Masculino"
            checked={template.gender === 'M'}
            onChange={this.setFieldValue}
          />
          <InputRadio
            name="gender"
            value="O"
            label="Deseja não declarar"
            checked={template.gender === 'O'}
            onChange={this.setFieldValue}
          />
        </FormItem>
        <FormItem label="Telefone para contato">
          <Input
            tag={TextMask}
            mask={masks.phoneNumber}
            name="phoneNumber"
            guide={false}
            value={template.phoneNumber}
            onChange={this.setFieldValue}
          />

          <label className="form-check">
            <Input
              type="checkbox"
              className="form-check-input"
              name="whatsapp"
              checked={!!template.whatsapp}
              onChange={this.setFieldValue}
            />
            Esse telefone pode ser utilizado no WhatsApp
          </label>
        </FormItem>
        <FormItem label="Data de nascimento">
          <Input
            style={styles.inputSm}
            tag={TextMask}
            mask={masks.date}
            pipe={masks.datePipe}
            keepCharPositions
            name="birthday"
            value={template.birthday}
            onChange={this.setFieldValue}
          />
        </FormItem>
        <FormItem label="Região">
          <Input
            placeholder="CEP"
            style={styles.inputSm}
            tag={TextMask}
            mask={masks.cep}
            name="postalCode"
            value={template.postalCode}
            onChange={this.setFieldValue}
          />
          <div style={styles.flexRow}>
            <Input
              style={styles.flex}
              placeholder="Cidade"
              name="city"
              value={template.city}
              onChange={this.setFieldValue}
            />
            <Input
              style={styles.inputState}
              placeholder="UF"
              name="state"
              value={template.state}
              onChange={this.setFieldValue}
            />
          </div>
        </FormItem>
      </Fragment>
    );
  };

  renderDocFields = () => {
    const { template } = this.state;

    return (
      <Fragment>
        <FormItem label="Habilitação">
          <Input
            style={styles.inputSm}
            name="license"
            value={template.license}
            onChange={this.setFieldValue}
          />
        </FormItem>
        <FormItem label="Identidade (RG)">
          <Input
            style={styles.inputSm}
            name="localId"
            value={template.localId}
            onChange={this.setFieldValue}
          />
        </FormItem>
        <FormItem label="CPF">
          <Input
            style={styles.inputSm}
            tag={TextMask}
            name="document"
            mask={masks.cpf}
            guide={false}
            value={template.document}
            onChange={this.setFieldValue}
          />
        </FormItem>
      </Fragment>
    );
  };

  renderAccessFields = () => {
    const { template } = this.state;
    const art = template.gender === 'M' ? 'ao' : 'à';

    return (
      <Fragment>
        <FormItem label="E-mail">
          <Input
            type="email"
            name="email"
            value={template.email}
            onChange={this.setFieldValue}
            autoComplete="new-email"
          />
        </FormItem>
        <FormItem label="Senha de acesso">
          <Input
            type="password"
            name="password"
            value={template.password}
            onChange={this.setFieldValue}
            autoComplete="new-password"
          />
          {this.state.isEditing && (
            <span className="input-hint">
              Deixe em branco caso não deseje alterar a senha do usuário. Preencha caso você deseje alterar a
              senha do usuário.
            </span>
          )}
        </FormItem>

        <hr className="form-separator" />

        <FormItem>
          <p>
            Deseja liberar o acesso à plataforma GoKids como Mãetorista? Essa opção pode ser alterada a
            qualquer momento.
          </p>
          <InputRadio
            style={styles.inputStyle}
            name="status"
            value="allowed"
            label={
              <span>
                <strong>
                  Sim, desejo liberar o acesso {art} mãetorista "{template.fullName || '???'}"
                </strong>{' '}
                - A mãetorista vai ter acesso ao aplicativo GoKids Mãetoristas.
              </span>
            }
            checked={template.status === 'allowed'}
            onChange={this.setFieldValue}
          />
          <InputRadio
            style={styles.inputStyle}
            name="status"
            value="not-allowed"
            label={
              <span>
                <strong>
                  Não liberar o acesso {art} mãetorista "{template.fullName || '???'}"
                </strong>{' '}
                - A mãetorista nao vai ter acesso ao aplicativo GoKids Mãetoristas no momento.
              </span>
            }
            checked={template.status === 'not-allowed'}
            onChange={this.setFieldValue}
          />
          <InputRadio
            name="status"
            value="in-review"
            label={
              <span>
                <strong>Ainda estou analisando - </strong> Marque essa opção caso você ainda não tenha
                decidido a situação da mãetorista.
              </span>
            }
            checked={template.status === 'in-review'}
            onChange={this.setFieldValue}
          />
        </FormItem>
      </Fragment>
    );
  };
}

DriverForm.propTypes = {
  //label: PropTypes.string,
};

const readFromServer = driver =>
  driver
    ? {
        email: driver.email,
        password: '',

        fullName: driver.fullName,
        nickname: driver.nickname,

        gender: driver.gender || 'F',
        phoneNumber: driver.phone.number,
        whatsapp: driver.phone.kind === 'whatsapp',
        document: driver.document,
        license: driver.license,
        localId: driver.localId,
        birthday: driver.birthday ? toDay(driver.birthday) : '',
        postalCode: driver.postalCode,
        city: driver.city,
        state: driver.state,

        status: driver.status
      }
    : {
        fullName: '',

        gender: 'F',
        email: '',
        password: ''
      };

const validateTemplate = template => {
  if (!template.fullName) return 'Preencha o nome completo';
  if (!template.gender) return 'Selecione o sexo da mãetorista';
  if (!template.phoneNumber || !isValidPhone(template.phoneNumber))
    return 'Preencha o número de telefone da mãetorista corretamente';

  if (!template.email) return 'Preencha o e-mail da mãetorista corretamente';
};

const readFromTemplate = template => ({
  email: template.email,
  password: template.password,
  nickname: template.nickname,

  fullName: template.fullName,
  gender: template.gender,
  phone: template.phoneNumber
    ? {
        number: toDigits(template.phoneNumber),
        kind: !!template.whatsapp ? 'whatsapp' : 'other'
      }
    : {},

  postalCode: template.postalCode,
  city: template.city,
  state: template.state,

  document: digits(template.document),
  license: template.license,
  localId: template.localId,
  birthday: readDate(template.birthday),

  status: template.status
});

const styles = {
  inputStyle: { marginBottom: 12 },
  inputSm: { maxWidth: 320 },
  flexRow: {
    display: 'flex',
    flexDirection: 'row',
    maxWidth: 320,
    marginTop: 8
  },
  flex: {
    flex: 1
  },
  inputState: {
    width: 80,
    marginLeft: 8
  }
};

export default DriverForm;



// WEBPACK FOOTER //
// ./src/screens/driver/DriverForm.js